import React from 'react';
import FullWidthInlineNotification from '../ErrorNotification/FullWidthInlineNotification';
import { ErrorBoundary } from '@dashboard-experience/utils';
import { i18n } from '@international/mastodon-i18n';
import { markCaughtByBoundary } from './caughtErrors';

function ErrorFallback() {
  return (
    <FullWidthInlineNotification
      kind='error'
      title={i18n.getStr('components.ErrorBoundary.title')}
      subtitle={i18n.getStr('components.ErrorBoundary.subtitle')}
      hideCloseButton
      data-testid='error-boundary-fallback'
    />
  );
}

// React renders the fallback before it logs the caught error to
// console.error, so the mark is in place when RUM sees that log.
const renderFallback = (error: Error) => {
  markCaughtByBoundary(error);
  return <ErrorFallback />;
};

type Props = {
  page: string;
  children: React.ReactNode;
};

export function ComponentErrorBoundary({ page, children }: Props) {
  return (
    <ErrorBoundary
      fallback={renderFallback}
      errorOptions={{ error_source: 'candidate_portal_error_boundary' }}
      scope={page}
    >
      {children}
    </ErrorBoundary>
  );
}

export const withBoundary = (
  element: React.ReactElement,
  page: string,
): React.ReactElement => (
  <ComponentErrorBoundary page={page}>{element}</ComponentErrorBoundary>
);
